/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import {
  NO_DATA,
  TEMPLATE_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_UNALLOCATED,
  payload: data,
});

export const setComputedFields = (data) => ({
  type: ActionTypes.SET_COMPUTED_FIELDS,
  payload: data,
});
export const setAmountNDCDeatils = (data) => ({
  type: ActionTypes.SET_AMOUNT_NDC_DETAILS,
  payload: data,
});

export const setAmountNDCDeatilsForExportAllPDF = (data) => ({
  type: ActionTypes.SET_AMOUNT_NDC_DETAILS_EXPORT_ALL,
  payload: data,
});

export const setNDCCodesForExportAllPDF = (data) => ({
  type: ActionTypes.SET_AMOUNT_NDC_CODES_EXPORT_ALL,
  payload: data,
});
export const setBalanceThreash = (data) => ({
  type: ActionTypes.SET_BALANCE_THREAD,
  payload: data,
});
export const setNDCCodes = (data) => ({
  type: ActionTypes.SET_NDC_CODES,
  payload: data,
});

export const setManufactureList = (data) => ({
  type: ActionTypes.SET_MANUFACTURERS_LIST_DIISPUTE_AMOUNT,
  payload: data,
});

export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.DISPUTE_AMOUNT_MANUFACTURER_LIST, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setManufactureList(response?.data?.disputeAmountReportVO || [])
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufactureList([]));
    });
};

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
}; 

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const getDisputeAmountComputedFields = (value) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setComputedFields([]));

  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_COMPUTED_FIELDS}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response.data.disputeAmountComputedFieldsDetailsVO &&
        response.data.disputeAmountComputedFieldsDetailsVO.length > 0
      ) {
        dispatch(
          setComputedFields(response.data.disputeAmountComputedFieldsDetailsVO)
        );
      } else {
        dispatch(showNoDataMessage());
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setComputedFields([]));
    });
};

export const getDisputeAmountAndNdcDetails = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_NDC_DETAILS}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setAmountNDCDeatils(response.data.disputeAmountNdcDetailsVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};
export const getDisputeNdcCodes = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_CODE_NDC}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(setNDCCodes(response.data.disputecodeNdcResponseVO));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNDCCodes([]));
    });
};

export const getBalanceThreshold = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_THRESHOLD}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setBalanceThreash(
          response?.data?.balanceDueThresholdVO.rptBalanceDueThreshold
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setBalanceThreash(0));
    });
};

export const exportAllPDFForDisputeAmountComputedFields =
  (value) => (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setAmountNDCDeatilsForExportAllPDF([]));
    return axios
      .post(`${serviceEndPoint.DISPUTE_AMOUNT_COMPUTED_FIELDS}`, value)
      .then((response) => {
        dispatch(setLoading(false));
        dispatch(
          setAmountNDCDeatilsForExportAllPDF(
            response.data.disputeAmountComputedFieldsDetailsVO
          )
        );
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch(setAmountNDCDeatilsForExportAllPDF([]));
      });
  };

export const exportAllPDFForDisputeNdcCodes = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_CODE_NDC}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setNDCCodesForExportAllPDF(response.data.disputecodeNdcResponseVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNDCCodesForExportAllPDF([]));
    });
};
export const refreshDisputeAmount = () => ({
  type: ActionTypes.REFRESH_DISPUTE_AMOUNT,
  payload: {},
});

export const refreshDisputeAmountDisplay = () => ({
  type: ActionTypes.REFRESH_DISPUTE_AMOUNT_DISPLAY,
  payload: {},
});
//dispatch DRAMS

export const dispatchDRAMS = (data) => ({
  type: ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

//get DRAMS Quarter

export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response?.data?.dramsInvoiceStartQuarter));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS(''));
    });
};

//dispatch Earliest Qtr

export const dispatchEarliestDrugQtr = (data) => ({
  type: ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE,
  payload: data,
});

//get Earliest Drag Quarter

export const getEarliestDrugQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EARLIEST_QTR_DRUG, value)
    .then((response) => {
      return dispatch(
        dispatchEarliestDrugQtr(
          response?.data?.earliestQtrForDrugDetailsVO?.defEarliestQtrForDrugDtls
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchEarliestDrugQtr(''));
    });
};

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_DISPUTE_AMOUNTS,
  payload: value,
});
